import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getListClientsByAppInstance } from '../apis';

const useGetListClientsByAppInstance = appInstanceId => {
	const queryClient = useQueryClient();
	const getListData = useQuery({
		queryKey: ['app-clients-list-by-app-instance-' + appInstanceId],
		queryFn: () => getListClientsByAppInstance(appInstanceId)
	});

	const customRefetch = () => {
		queryClient.removeQueries('app-clients-list-by-app-instance-' + appInstanceId);

		queryClient.refetchQueries('app-clients-list-by-app-instance-' + appInstanceId);
	};

	return { ...getListData, customRefetch };
};

export default useGetListClientsByAppInstance;
